<template>
  <div class="step_content">
    <h3>Оценка вашего риска</h3>
    <p>
      Мы зададим вам несколько вопросов о здоровье. Ответы помогут создать ваш
      персонализированный профиль риска и сформировать рекомендации.
    </p>
  </div>
</template>
<script>
export default {
  name: "StepWelcome",
};
</script>

<style>
.step_content {
  /*   min-height: 100%; */
}
</style>
